module.exports = __webpack_public_path__ + "img/item9-1.bb631253.jpeg";